/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import Text from '../../basic/Text';
import { useFormStoreFieldError } from "../FormStore";

type InputMessagesProps = { name: string };
export const InputMessages: Component<InputMessagesProps> = ({ name }) => {
  const fieldError = useFormStoreFieldError(name);

  // Don't show error message for required field validation (special marker)
  if (!fieldError || fieldError === '__REQUIRED__') {
    return null;
  }

  return (
    <>
      <InputMessage key={fieldError} type="error">
        {fieldError}
      </InputMessage>
    </>
  );
};

type InputMessage = {
  type?: "description" | "error" | "warning" | "info";
};

export const InputMessage: ComponentWithChildren<InputMessage> = ({
  type = "error",
  children,
  sx,
  ...props
}) => {
  return (
    <Text
      variant="text.form.message"
      sx={{
        fontSize: "0.75rem",
        ...(type === "error" && { color: "error.main" }),
        ...sx,
      }}
      {...props}
    >
      {children}
    </Text>
  );
};
